import { ToasterInfo, UXAction, uxConsts } from "../types/ux";

export interface UXState {
  progressText: string;
  progressCounter: number;
  toaster: ToasterInfo;
}

const initialState: UXState = {
  progressText: "",
  progressCounter: 0,
  toaster: {
    open: false,
    message: "",
    variant: "success",
    vertical: "top",
    horizontal: "right"
  }
};

export default function appSettings(
  state = initialState,
  action: UXAction
): UXState {
  switch (action.type) {
    case uxConsts.SHOW_PROGRESS:
      return {
        ...state,
        progressCounter: state.progressCounter + 1,
        progressText: action.progressText
      };
    case uxConsts.HIDE_PROGRESS:
      return {
        ...state,
        progressCounter: Math.max(0, state.progressCounter - 1)
      };
    case uxConsts.SHOW_TOASTER:
      return { ...state, toaster: action.toaster };
    case uxConsts.HIDE_TOASTER:
      return { ...state, toaster: { ...state.toaster, open: false } };
    default:
      return state;
  }
}
